module.exports = __webpack_public_path__ + "static/img2-e3b0429dbc1ea8712f53df385f54f9ff.png";